export interface SettingsAttributeCategoryData {
  categoryId?: string;
  attributeCategoryId?: string;
  name?: string;
  numberOfAttributeDefinitions?: number;
}

export class SettingsAttributeCategory {
  categoryId: string | undefined;
  name: string | undefined;
  numberOfAttributeDefinitions: number;
  isInUsed: boolean;

  constructor(data?: SettingsAttributeCategoryData) {
    this.numberOfAttributeDefinitions = 0;
    this.isInUsed = false;

    if (data) {
      this.categoryId = data.categoryId || data.attributeCategoryId;
      this.name = data.name;
      this.numberOfAttributeDefinitions = data.numberOfAttributeDefinitions || 0;
      this.isInUsed = this.numberOfAttributeDefinitions !== 0;
    }
  }
}
